/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { LinkArr, Next, Prev } from "../../common/svg/AllSvg";
import TripPlanner from "./TripPlanner";
import Slider from "react-slick";
import Tickets from "../../../assets/images/Tickets.svg";
import LostFound from "../../../assets/images/LostFound.svg";
// import BannerImg from "../../../assets/images/banner1.png";
// import BannerImg2 from "../../../assets/images/banner2.png";
import BannerImg3 from "../../../assets/images/banner3.png";
import BannerImg4 from "../../../assets/images/banner4.png";
// import BannerImg5 from "../../../assets/images/banner5.png";
// import BannerImg6 from "../../../assets/images/banner6.png";
// import BannerImg7 from "../../../assets/images/banner7.png";
// import BannerImg8 from "../../../assets/images/banner8.png";
// import BannerImg9 from "../../../assets/images/banner9.png";
import BannerImg10 from "../../../assets/images/banner10.png";
// import BannerImg11 from "../../../assets/images/banner11.png";
import BannerImg12 from "../../../assets/images/banner12.png";
import BannerImg13 from "../../../assets/images/banner13.png";
import BannerImg14 from "../../../assets/images/banner14.png";
import BannerImg15 from "../../../assets/images/banner15.png";
import BannerImg16 from "../../../assets/images/banner16.png";
import { url } from "../../../shared/utils/url";
import { useDispatch, useSelector } from "react-redux";
import useAxios from "../../../shared/hooks/use-axios";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import { dataActions } from "../../../shared/store/data-Slice";

const Banner = () => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const isLogin: boolean = useSelector((state: any) => state.auth.isLogin);
    const [data, setData] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const arrowRef: any = useRef(null);
    const { t } = useTranslation('common');
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const settings = {
        dots: true,
        arrows: false,
        infinite: data?.length > 1 ? true : false,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true
    }

    const settings1 = {
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        fade: true
    }

    const getNotice = async () => {
        try {
            setLoading(true)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url.notice}`);

            if (res && res.status === 200) {
                setData(res?.data)
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            console.error("error while fetching notice", error);
        }
    }

    useEffect(() => {
        !!lang && getNotice();
    }, [lang])

    const handleLink = (item: any) => {
        dispatch(dataActions.setWebOpen(true));
        dispatch(dataActions.setLink(item));
    }

    return (
        <div className="px-[18px] xlsm:px-[25px] xlx:px-[45px] pt-[15px] xsm:pt-[22px] xlx:pt-[25px] pb-[18px] xsm:pb-[30px] xlx:pb-[44px] flex items-center justify-center w-full h-full">
            <div className="flex w-[1200px] xlx:w-[1384px] h-full gap-[15px] xlx:gap-[25px]">
                {/* trip planner */}
                {window.innerWidth >= 1200 && <div className="hidden lgl:block w-full lgl:w-[415px]">
                    <TripPlanner />
                </div>}

                {/* banner */}
                <div className="flex flex-col gap-[15px] h-full w-full lgl:w-[calc(100%-430px)] xlx:w-[calc(100%-440px)]">
                    <div className="grid grid-cols-1 w-full">
                        <Slider className="banner-slider" {...settings1}>
                            <img src={BannerImg15} alt="Banner" className="w-full h-full rounded-[15px] xsm:rounded-[25px]" />
                            <img src={BannerImg10} alt="Banner" className="w-full h-full rounded-[15px] xsm:rounded-[25px]" />
                            <img src={BannerImg16} alt="Banner" className="w-full h-full rounded-[15px] xsm:rounded-[25px]" />
                            <img src={BannerImg12} alt="Banner" className="w-full h-full rounded-[15px] xsm:rounded-[25px]" />
                            <img src={BannerImg13} alt="Banner" className="w-full h-full rounded-[15px] xsm:rounded-[25px]" />
                            <img src={BannerImg14} alt="Banner" className="w-full h-full rounded-[15px] xsm:rounded-[25px]" />
                            <img src={BannerImg3} alt="Banner" className="w-full h-full rounded-[15px] xsm:rounded-[25px]" />
                            <img src={BannerImg4} alt="Banner" className="w-full h-full rounded-[15px] xsm:rounded-[25px]" />
                        </Slider>
                    </div>
                    <div className="grid grid-cols-1 w-full">
                        <div className="flex gap-[15px] md:flex-row flex-col w-full">
                            {/* trip planner */}
                            {window.innerWidth <= 1200 && <div className="block lgl:hidden w-full md:w-[50%] mm:w-[415px]">
                                <TripPlanner />
                            </div>}

                            <div className="grid grid-cols-1 xsm:grid-cols-2 lgl:grid-cols-4 items-center gap-[15px] lgl:col-span-2 h-full w-full md:w-[50%] mm:w-[calc(100%-430px)] lgl:w-full">
                                <button className="bg-[#C383D9] rounded-[20px] min-h-[182px] md:min-h-[150px] lg:min-h-[182px] xlx:min-h-[200px] w-full h-full relative p-[18px] md:p-[15px] msm:p-[20px] lgl:p-[15px] xlx:p-[20px] backdrop-blur-[0.5px] shadow-sm flex items-start justify-start focus:shadow-[0_0_0_3px_#C383D95e] hover:shadow-[0_0_0_3px_#C383D95e]" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/ncmc-on-mumbai-metro-line-3`) : navigate(`/ncmc-on-mumbai-metro-line-3`)}>
                                    <h3 className="text-white text-[14px] xlx:text-[16px] leading-tight font-bold uppercase max-w-[91px] pb-[15px] text-left">{t("passenger.home.banner.ticket")}</h3>
                                    <div className="absolute top-0 left-0 right-0 bottom-0 flex items-end justify-center">
                                        <img src={Tickets} alt="Tickets" className="rounded-b-[20px] w-full h-[160px] md:h-auto mm:h-[160px] lgl:h-auto" />
                                    </div>
                                </button>

                                <button className="bg-[#6592FD] rounded-[20px] min-h-[182px] md:min-h-[150px] lg:min-h-[182px] xlx:min-h-[200px] w-full h-full relative p-[18px] md:p-[15px] msm:p-[20px] lgl:p-[15px] xlx:p-[20px] backdrop-blur-[0.5px] shadow-sm flex flex-col items-start justify-start focus:shadow-[0_0_0_3px_#6592FD5e] hover:shadow-[0_0_0_3px_#6592FD5e]"
                                    onClick={() => { if (!isLogin) { dispatch(dataActions.setLoginOpen(true)) } else { !!params?.lang ? navigate(`/${params?.lang}/lost-found/report-lost-item`) : navigate(`/lost-found/report-lost-item`) } }}
                                // onClick={() => !!params?.lang ? navigate(`/${params?.lang}/lost-found`) : navigate(`/lost-found`)}
                                >
                                    <h3 className="text-white text-[14px] xlx:text-[16px] leading-tight font-bold uppercase text-left">{t("passenger.home.banner.lost_found")}</h3>
                                    <p className="text-white text-[12px] xlx:text-[14px] font-normal pb-[15px] leading-tight text-left">{t("passenger.home.banner.lost_found_desc")}</p>
                                    <div className="absolute top-0 left-0 right-0 bottom-0 flex items-end justify-center">
                                        <img src={LostFound} alt="Lost&Found" className="2xl:w-auto lgl:w-[145px] xlx:w-[148px]" />
                                    </div>
                                </button>

                                {/* notices & alerts */}
                                <div className="border dark:border-[#178DD0] border-[#5FC5FF] dark:bg-[#072F3B] bg-[#EBFAFF] backdrop-blur-[0.5px] rounded-[20px] w-full xsm:col-span-2 h-full">
                                    <div className="h-[35px] rounded-t-[20px] px-[23px] dark:bg-bgDarkDull bg-white backdrop-blur-[0.5px]">
                                        <button className="flex items-center gap-[7px] hover:underline focus:underline h-full text-primaryText dark:text-white" onClick={() => !!params?.lang ? navigate(`/${params?.lang}/notice`) : navigate(`/notice`)}>
                                            <h4 className="text-primaryText dark:text-white font-bold uppercase text-base leading-snug">{t("passenger.home.banner.notice")}</h4>
                                            <LinkArr className="fill-primaryText dark:fill-white" />
                                        </button>
                                    </div>

                                    {loading ?
                                        <div className="flex flex-col gap-[5px] w-full py-[15px] xlx:py-[20px] px-[23px]">
                                            <div className="w-full h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                            <div className="w-full h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                            <div className="w-[60px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                        </div>
                                        :
                                        <>
                                            {data?.length > 0 && <div className="h-[calc(100%-35px)] rounded-b-[20px] w-full px-[23px] pb-[15px]">
                                                <Slider className='h-[calc(100%-25px)] w-full notice-slider' ref={arrowRef} {...settings} >
                                                    {Array.isArray(data) && data.map((item: any, index: number) => (
                                                        <div className="!flex items-center h-full py-[15px] xlx:py-[20px]" key={index}>
                                                            {(!!item?.link_to_outside_url || !!item?.link_to_file?.file || !!item?.link_to_internal_page) ?
                                                                <Link to={!!item?.link_to_outside_url ? item?.link_to_outside_url : !!item?.link_to_internal_page ? item?.link_to_internal_page : item?.link_to_file?.file} target={(!!item?.link_to_outside_url || !!item?.link_to_file?.file) ? "_blank" : "_self"} className="text-primaryText dark:text-textBlackDull font-medium text-base *:text-primaryText *:dark:text-textBlackDull *:font-medium *:text-base line-clamp-4 *:line-clamp-4 focus:*:underline hover:*:underline focus:underline hover:underline" dangerouslySetInnerHTML={{ __html: item?.html_message }} onClick={(e: any) => { !!item?.link_to_outside_url && e.preventDefault(); !!item?.link_to_outside_url && handleLink(item?.link_to_outside_url); }} />
                                                                :
                                                                <h5 className="text-primaryText dark:text-textBlackDull font-medium text-base *:text-primaryText *:dark:text-textBlackDull *:font-medium *:text-base line-clamp-4 *:line-clamp-4" dangerouslySetInnerHTML={{ __html: item?.html_message }} />}
                                                        </div>
                                                    ))}
                                                </Slider>

                                                <div className="w-full flex items-center justify-end gap-[5px] z-[1] relative">
                                                    <button aria-label={t("aria_label.prev_arr")}
                                                        title={t("aria_label.prev")} className="min-w-[26px] h-[26px] flex items-center justify-center rounded-full border border-transparent dark:border-[#DCDCDC] dark:bg-opacity-[0.2] dark:bg-[#898989] bg-[#dae6ea] focus:shadow-[0_0_0_2px_#3d3d3d5e] hover:shadow-[0_0_0_2px_#3d3d3d5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => arrowRef.current.slickPrev()}>
                                                        <Prev className="fill-[#3d3d3d] dark:fill-[#6294FF]" />
                                                    </button>
                                                    <button aria-label={t("aria_label.next_arr")}
                                                        title={t("aria_label.next")} className="min-w-[26px] h-[26px] flex items-center justify-center rounded-full border border-transparent dark:border-[#DCDCDC] dark:bg-opacity-[0.2] dark:bg-[#898989] bg-[#dae6ea] focus:shadow-[0_0_0_2px_#3d3d3d5e] hover:shadow-[0_0_0_2px_#3d3d3d5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => arrowRef.current.slickNext()}>
                                                        <Next className="fill-[#3d3d3d] dark:fill-[#6294FF]" />
                                                    </button>
                                                </div>
                                            </div>}
                                        </>
                                    }
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    );
};

export default Banner;